import ActionDropdown from "./ActionDropdown";

export default function MetadataSection({ car, onActionDropdownClick }) {
  const handleActionDropdownClick = (data) => {
    onActionDropdownClick({ action: data.name, id: car.id });
  };

  return (
    <div className="rounded-lg p-2 border-2 ">
      <div className="flex justify-between text-sm">
        <div className="text-gray-700 flex flex-col gap-0.5">
          <p>
            <span className="font-bold ">Fecha de creación: </span>
            {car.createdAt}
          </p>
          <p>
            <span className="font-bold">Fecha de publicación: </span>
            {car.publishedAt}
          </p>
          {car.removedAt && (
            <p>
              <span className="font-bold">Fecha de baja: </span>
              {car.removedAt}
            </p>
          )}
        </div>
        <div>
          <ActionDropdown
            carId={car.id}
            statusId={car.status}
            onClick={handleActionDropdownClick}
          />
        </div>
      </div>
    </div>
  );
}
